import { Box, Typography } from '@mui/material'
import { useState } from 'react'
import SideMenu from 'Components/SideMenuRefactored/SideMenu'
import LeaderboardTabContainer from 'Components/LeaderboardTabContainer/LeaderboardTabContainer'
import LeaderboardtabreadCrumb from 'Components/LeaderboardTabContainer/LeaderboardtabreadCrumb/LeaderboardtabreadCrumb'

const LeaderboardTab = () => {
  const [isChange, setIsChange] = useState(false)
  const [selectedTab, setSelectedTab] = useState(0)
  const [editData, setEditData] = useState(null)
  const [promptOnTabChange, setPromptOnTabChange] = useState(false)
  const [showConfirmDialog, setShowConfirmDialog] = useState(false)
  const [pendingTabIndex, setPendingTabIndex] = useState(null)

  return (
    <Box className="page-wrapper d-flex seva-initiatives-outer-container">
      <SideMenu
        activeTab={'Settings'}
        settingsTab={isChange}
        promptOnTabChange={promptOnTabChange}
        setPromptOnTabChange={setPromptOnTabChange}
      />
      <Box className="main-wrapper customscroll w-100 p-5">
        <Typography component="h1" className="seva-initiatives-title-text settings-header">
          Leaderboard Tabs
        </Typography>
        <LeaderboardtabreadCrumb
          selectedTab={selectedTab}
          editData={editData}
          setSelectedTab={setSelectedTab}
          setEditData={setEditData}
          promptOnTabChange={promptOnTabChange}
          setShowConfirmDialog={setShowConfirmDialog}
          setPendingTabIndex={setPendingTabIndex}
        />
        <LeaderboardTabContainer
          selectedTab={selectedTab}
          setSelectedTab={setSelectedTab}
          editData={editData}
          setEditData={setEditData}
          promptOnTabChange={promptOnTabChange}
          setPromptOnTabChange={setPromptOnTabChange}
          showConfirmDialog={showConfirmDialog}
          setShowConfirmDialog={setShowConfirmDialog}
          pendingTabIndex={pendingTabIndex}
          setPendingTabIndex={setPendingTabIndex}
        />
      </Box>
    </Box>
  )
}

export default LeaderboardTab
